export default __webpack_public_path__ + "static/media/FIFA_World_Cup_trophy580.c9d7c274.png";